export default "__VITE_ASSET__CjBoanFH__"